module.exports = __webpack_public_path__ + "static/media/twoHearts.fdbc6795.png";